import * as React from 'react';

import { isMobile } from 'react-device-detect';
import { createStyles, Theme, makeStyles } from '@material-ui/core';

import { useClassName } from '../../../utils/useClassName';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mobile: {},
    root: {
      width: '100%',
      minHeight: '48px',
      display: 'flex',
      alignContent: 'center',
      '$mobile&': {
        height: '100%',
        padding: '0px 8px'
      }
    },
    menubutton: {
      minHeight: theme.spacing[10],
      marginTop: 'auto',
      marginBottom: 'auto',
      '$mobile &': {
        height: 60,
        alignContent: 'center'
      }
    },
    buttonGroup: {
      display: 'flex',
      alignContent: 'center',
      gap: '8px'
    },
    // menuButton container
    menugroup: {
      minWidth: '225px'
    },

    primaryButtons: {
      justifySelf: 'flex-start',
      flexGrow: 0
    },
    children: {
      justifySelf: 'center',
      flexGrow: 1,
      alignItems: 'center'
    },
    secondaryButtons: {
      justifySelf: 'flex-start',
      flexGrow: 0
    },
    mobileFullWidth: {
      width: 'calc(100vw - 70px)',
      justifyContent: 'space-between'
    }
  })
);

interface BaseProps {
  primaryButtons?: React.ReactNode;
  secondaryButtons?: React.ReactNode;
}

export const CommandBarBaseUI: React.FC<React.PropsWithChildren<BaseProps>> = (
  props
) => {
  const { children, primaryButtons, secondaryButtons } = props;

  const classes = useStyles(props);

  //while is mobile and there are no children, we want the bar to take the full width
  const mobileFullWidth = isMobile && !children && !secondaryButtons;

  return (
    <div
      data-type="librarydeselectoverride"
      data-cy="commandBar"
      className={`${classes.root} ${isMobile ? classes.mobile : ''}`}
    >
      <div
        className={useClassName(
          classes.primaryButtons,
          classes.buttonGroup,
          mobileFullWidth ? classes.mobileFullWidth : ''
        )}
      >
        {primaryButtons}
      </div>

      <div className={useClassName(classes.children, classes.buttonGroup)}>
        {children}
      </div>

      {secondaryButtons && (
        <div
          className={useClassName(
            classes.secondaryButtons,
            classes.buttonGroup
          )}
        >
          {secondaryButtons}
        </div>
      )}
    </div>
  );
};

export { useStyles as useCommandBarBaseStyles };
